var vars = require('./core');

module.exports = vars.createClass('Bar', ['getBarsAtEvent']);



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs/lib/bar.js
// module id = 180
// module chunks = 0